import React from "react";
import Dialog from "../../../components/Dialog/Dialog";
import { Switch, Tooltip, withStyles } from "@material-ui/core";
import { inject } from "mobx-react";
import CloseIcon from "../../../components/Icon/Close";
import { TextFieldSearch } from "../../../components/TextField";
import InputForm from "../../../components/Input/InputForm";
import TesteCurvas from "./TesteCurvas";
import { Button } from "../../../components/ui/Buttons";
import TestePaternidade from "./TestePaternidade";
import CamposExame from "./CamposExame";
import FormularioMedidas from "./FormularioMedidas";
import { findAllExameDasaTipo } from "../../../services/ExamesService";
import { observer } from "mobx-react-lite";
import InputDateForm from "../../../components/Input/InputDateForm";
import InfoIcon from "../../../components/Icon/InfoIcon";
import { findAllProfissionalSaude } from "../../../services/ProfissionalSaudeService";
import CurvaPeriodos from "./CurvaPeriodos";
import SexagemFetal from "./SexagemFetal";
import ModalAlerta from "../../Atendimento/Internacao/components/ModalAlerta";
import AtencaoIcon from "../../../components/Icon/AtencaoIcon";

const EXAMES_COM_OBSERVACAO = ["VOLUME","PADRAO"]


const ModalExames = observer(({ 
  classes,
   open,
    exameStore, 
    sujeitoAtencaoStore,
    findAllExameDasa,
  }) => {

  const componentesExames = {
  TESTE_PATERNIDADE: TestePaternidade,
  MEDIDAS: FormularioMedidas,
  CURVA: TesteCurvas,
  CURVA_PERIODO: CurvaPeriodos,
  SEXAGEM_FETAL: SexagemFetal,
  PADRAO:  null,
};

    const handleField = (event, field) => {  
      exameStore.changeDadosExame(event, field);
    };

    const loadAllTipoExames = async (search, loadedOptions, { page }) => {
      try {
        const variables = {
          pageableDto: {
            pageNumber: page,
            pageSize: 10,
            sortDir: "ASC",
            sortField: "descricao",
          },
          search,
        };
        
        const { content, last } = (await findAllExameDasaTipo(variables)).data.data.findAllExameDasaTipo;
        return {
          options: content,
          hasMore: !last,
          additional: { page: page + 1 },
        };
      } catch (error) {
        console.error(error);
      }
    };

    const handleClickAdicionar = async () => {
      try {
        const response = await exameStore.incluirExameDasa();
        if (response?.error) {
          sujeitoAtencaoStore.openNotification(response.error, "error");
        } else if (response?.id) {
          sujeitoAtencaoStore.openNotification("Exame adicionado com sucesso!", "success");
          findAllExameDasa({resetValues: true})

          exameStore.clear();
        }
      } catch (error) {
        console.error(error)
       
      }
    };

  const loadProfissionaisSaude = async (search, loadedOptions, { page }) => {
    try {
      const { content, last } = (
        await findAllProfissionalSaude({
          pageNumber: page,
          search,
        })
      ).data.data.findAllProfissionalSaude
      return {
        options: content,
        hasMore: !last,
        additional: {
          page: page + 1,
        },
      }
    } catch (error) {
      console.error(error)
    }

  }

    const tipoSelecionado = exameStore?.exame?.tipoExame?.tipo;

    const ComponenteRenderizado =componentesExames[tipoSelecionado] || (() => <></>);
      
    return (
      <>
        <Dialog open={open} classes={{ paper: classes.dialogPaper }}>
          <div className={classes.modalContainer}>
            <header className={classes.header}>
              <h2 className={classes.title}>Exames</h2>
              <button
                id="pac-exa-btn-fch"
                onClick={() => exameStore.togleOpenModalExames()}
                className={classes.close}
              >
                <CloseIcon />
              </button>
            </header>
            <div className={classes.body}>
              <section className={classes.contentSelect}>
                <div className={classes.wrapperSelect}>
                  <label className={classes.label}>Adicionar:</label>
                  <TextFieldSearch
                    id="pac-exa-txt-tip"
                    placeholder="Selecione"
                    loadOptions={loadAllTipoExames}
                    getOptionLabel={(option) => option.label || option.descricao}
                    getOptionValue={(option) => option.value || option.codigo}
                    value={exameStore?.exame?.tipoExame}
                    onChange={(e) => handleField(e, "tipoExame")}
                    withPaginate
                    debounceTimeout={300}
                    additional={{ page: 0 }}
                    menuPosition="fixed"
                  />
                </div>
                <div className={classes.wrapperSelectProfissional}>
                  <label className={classes.label}>Profissional Solicitante:</label>
                  <TextFieldSearch
                    id="pac-exa-txt-pro"
                    placeholder="Selecione"
                    loadOptions={loadProfissionaisSaude}
                    getOptionLabel={(option) => option.label || option.nome}
                    getOptionValue={(option) => option.value || option.id}
                    value={exameStore?.exame?.profissionalSolicitante}
                    onChange={(e) => handleField(e, "profissionalSolicitante")}
                    withPaginate
                    debounceTimeout={300}
                    additional={{ page: 0 }}
                    menuPosition="fixed"
                  />
                </div>
                <div className={classes.wrapperSelectData}>
                  <Tooltip
                    placement="top"
                    title={
                      "Data de coleta : mínimo 10 dias antes e 15 dias após a data atual"
                    }
                  >
                    <label className={classes.labelColeta}>
                      Data da coleta <InfoIcon />
                    </label>
                  </Tooltip>
                  <InputDateForm
                    id="pac-exa-inp-dtc"
                    placeholder="00/00/0000"
                    onChange={(event) => handleField(event, "dataColeta")}
                    value={exameStore?.exame?.dataColeta}
                    iconposition="end"
                  />
                </div>
              </section>
              <CamposExame />
              <div className={classes.renderComponente}>
                <ComponenteRenderizado />
               {exameStore?.exame?.tipoExame?.tipo === "VOLUME" && <div className={classes.volume}>
                  Volume*
                   <InputForm
                      id="pac-exa-inp-vol"
                      type="number"
                      onChange={(e) => handleField(e?.target.value, "volume")}
                      value={exameStore?.exame?.volume}
                      classes={{ input: classes.input }}
                      placeholder={'Volume'}
                    />
                </div>}
              </div>
              {EXAMES_COM_OBSERVACAO.includes(exameStore?.exame?.tipoExame?.tipo) && (
                <section className={classes.contentObservacao}>
                  <div className={classes.wraperObsSwitch}>
                    <label className={classes.label}>Observação</label>
                    <InputForm
                      id="pac-exa-inp-obs"
                      onChange={(e) => handleField(e?.target.value, "observacao")}
                      value={exameStore?.exame?.observacao}
                      classes={{ input: classes.inputObservacao }}
                    />
                  </div>
                  <div className={classes.wraperObsSwitch}>
                    <label className={classes.label}>Urgente</label>
                    <Switch
                      id="pac-exa-swi-urg"
                      color="primary"
                      onChange={() =>
                        handleField(!exameStore?.exame?.urgente, "urgente")
                      }
                      checked={exameStore?.exame?.urgente}
                    />
                  </div>
                </section>
              )}
            </div>
            <footer className={classes.contenButton}>
              <Button id="pac-exa-btn-vol" kind="transparent" onClick={() => exameStore.togleOpenModalExames()}>
                Voltar
              </Button>
              <Button id="pac-exa-btn-add" width={"50%"} onClick={handleClickAdicionar} disabled={!exameStore.isFormValid() || exameStore.isLoading}>
                Adicionar
              </Button>
            </footer>
          </div>
        </Dialog>
        <ModalAlerta 
          open={exameStore.modalAlerta?.open}
          onClose={() => exameStore.closeModalAlerta()}
          modalIcon={<AtencaoIcon size={64}/>}
          title={exameStore.modalAlerta?.title}
          messageContent={exameStore.modalAlerta?.message}
          onClickButton={() => exameStore.closeModalAlerta()}
          secondaryButtonLabel={"ok"}
          onSecondaryAction={() => exameStore.closeModalAlerta()}
        />
      </>
    );
  }
);

const styles = {
  dialogPaper: {
    width: "100%",
    maxWidth: "1023px",
    height: "100%",
    padding: "18px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  modalContainer: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    height: "100%",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  title: {
    fontSize: "18px",
  },
  close: {
    cursor: "pointer",
    background: "none",
    border: "none",
  },
  body: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    overflowY: "auto",
    paddingTop: "12px",
  },
  contentSelect: {
    display: "flex",
    flexDirection: "row",
    gap: "10px",
    alignItems: "flex-end",
  },
  wrapperSelect: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
  },
  wrapperSelectData: {
    display: "flex",
    flexDirection: "column",
  },
  label: {
    fontSize: "12px",
    color: "#868686",
  },
  labelColeta: {
    fontSize: "12px",
    color: "#868686",
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },
  contentObservacao: {
    display: "grid",
    gridTemplateColumns: "3fr 1fr",
    gap: "10px",
    paddingTop: "10px",
    alignItems:"center",
  },
  wraperObsSwitch: {
    display: "flex",
    flexDirection: "column",
  },
  renderComponente: {
    borderTop: "1px solid #ccc",
    paddingTop: "12px",
  },
  contenButton: {
    display: "flex",
    justifyContent: "space-around",
    paddingTop: "10px",
  },
  wrapperSelectProfissional:{
    width:"200px"
  },
  volume:{
    display:"flex",
    flexDirection:"column",
    gap:"10px",
    paddingTop:"10px",
    fontSize:"14px",
    color:"#868686"
  },
  input:{
    background: "#f2f2f2",
    border: "none",
    paddingTop: "6px !important",
    color: "#868686",
    width: "200px"
  },
  inputObservacao:{
    background: "#f2f2f2",
    border: "none",
    paddingTop: "6px !important",
    color: "#868686",
    width: "100%"
  }
};

const ModalExameWithStyles = withStyles(styles)(ModalExames);
export default inject("exameStore", "sujeitoAtencaoStore")(ModalExameWithStyles);